<script setup lang="ts">
const pixelPatternLeft = ['1111111111', '1111  1   ', '21111     ', '21111111  ', '1122111   ', ' 1 21     '].join('\n')
const pixelPatternRight = ['          ', '        11', '   1111  1', '  21111111', '  11  1111', '   1 21   '].join(
  '\n'
)

withDefaults(
  defineProps<{
    title?: string
    country?: string
    grid?: boolean
  }>(),
  {
    grid: true,
  }
)
</script>

<template>
  <header class="z-0 flex w-full justify-center">
    <template v-if="grid">
      <!-- <PixelGrid :pattern="pixelPatternLeft" :size="36" class="absolute left-4 z-0 hidden h-40 md:flex lg:left-8" /> -->
      <!-- <PixelGrid :pattern="pixelPatternLeft" :size="30" class="absolute left-4 z-0 flex h-40 md:hidden lg:left-8" /> -->
      <!-- <PixelGrid :pattern="pixelPatternRight" :size="36" class="absolute right-4 z-0 hidden h-40 md:flex lg:right-8" /> -->
    </template>

    <div class="relative mb-8 mt-32 flex flex-col gap-y-2 px-8 text-center md:px-0">
      <Motion
        v-if="$slots.eyebrow"
        :initial="{opacity: 0, y: -16}"
        :animate="{opacity: 1, y: 0}"
        :transition="{ease: [0.16, 1, 0.3, 1], duration: 1}"
      >
        <Paragraph size="normal" class="text-gray-600">
          <slot name="eyebrow" />
        </Paragraph>
      </Motion>

      <Motion
        v-if="title"
        :initial="{opacity: 0, y: -16}"
        :animate="{opacity: 1, y: 0}"
        :transition="{ease: [0.16, 1, 0.3, 1], duration: 1, delay: 0.1}"
      >
        <Heading size="large" gradient="gray" as="h1">
          {{ title }}

          <span v-if="country" class="sr-only">
            {{ country }}
          </span>
        </Heading>
      </Motion>

      <Motion
        v-if="$slots.description"
        :initial="{opacity: 0, y: -16}"
        :animate="{opacity: 1, y: 0}"
        :transition="{ease: [0.16, 1, 0.3, 1], duration: 1, delay: 0.2}"
        class="flex justify-center"
      >
        <Paragraph size="medium" class="max-w-2xl text-gray-700" weight="normal">
          <slot name="description" />
        </Paragraph>
      </Motion>
    </div>
  </header>
</template>
